import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import Achievement from "../../containers/achievement/Achievement";
import "./achievement.css";
import AchievementImg from "./AchievementImg.js";
import { Fade } from "react-reveal";
import { achievementSection } from "../../portfolio";

class Achievements extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="achievement-main">
        <Header theme={theme} />
        <div className="basic-achievement">
          <Fade bottom duration={2000} distance="40px">
            <div className="achievement-heading-div">
              <div className="achievement-heading-img-div">
                <AchievementImg theme={theme} />
              </div>
              <div className="achievement-heading-text-div">
                <h1
                  className="achievement-heading-text"
                  style={{ color: theme.text }}
                >
                  {achievementSection
                    ? achievementSection.title
                    : "Achievement"}
                </h1>
                <h3
                  className="achievement-heading-sub-text"
                  style={{ color: theme.text }}
                >
                  {achievementSection ? achievementSection.subtitle : ""}
                </h3>
                <p
                  className="achievement-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {achievementSection ? achievementSection.description : ""}
                </p>
              </div>
            </div>
          </Fade>
        </div>
        <Achievement theme={theme} />
        <Footer theme={theme} onToggle={this.props.onToggle} />
        <TopButton theme={theme} />
      </div>
    );
  }
}

export default Achievements;
